import PluginClientProvider, { HttpResponse, PluginResponse } from "./base_provider";


export interface FetchClientProvider extends PluginClientProvider {
    doRequest<T>(url: string, configs: RequestInit): Promise<PluginResponse<T>>
}


interface CustomErrorOptions extends ErrorOptions {
    status?: number;
    code?: string;
}

class CustomError extends Error {
    status: number;
    code: string;

    constructor(message: string, options?: CustomErrorOptions) {
        super(message, { cause: options?.cause });
        this.status = options?.status || 500;
        this.code   = options?.code || 'GENERAL_ERROR';
    }
}


const FetchProvider: FetchClientProvider = {
    async doRequest<ResponseData>(url: string, configs: RequestInit): Promise<PluginResponse<ResponseData>> {
        const response: HttpResponse<PluginResponse<ResponseData>> = await fetch(url, configs);

        if (!response.ok) {
            const errorOptions: CustomErrorOptions = {
                status: response.status,
                cause: response.statusText
            }

            throw (new CustomError(response.statusText, errorOptions));
        }

        // may error if there is no body
        response.parsedBody = await response.json();

        if (!response.parsedBody) {
            throw new Error("Got Empty response");
        }

        return response.parsedBody;
    }
};

export default FetchProvider;
